const fetchCounter = ({ http }) => http.get('/count/all', { withCredentials: false })
  .then(({ data }) => data)
  .then(({ offersCount, jobCenterOffersCount }) => offersCount + jobCenterOffersCount);

export default fetchCounter;
